/****************************************************
 * Module Name:  memoReport.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from 'react';
import Constants from '../../utility/constants';
import MemoComponent from '../common/memoComponent';
import NoPermission from '../common/noPermission';

const MemoReport = () => {
    const [local_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.REPORT_MEMO_REPORTMEMO
        )
    );

    return (
        <div>
            {local_Permission ?
                (<MemoComponent
                    isReport={true}
                    hasPermission={local_Permission.length > 0}
                />) : <NoPermission />}

        </div>
    );
}

export default MemoReport;